import React from 'react';
import { useParams } from 'react-router-dom';

import MicroApp from '../../components/MicroApp';
import useServicesSettings from './use-services-settings';

export function EditCourse() {
  const { isLoading, settings } = useServicesSettings();
  const { courseId } = useParams<'courseId'>();

  if (isLoading) {
    return null;
  }

  return (
    <MicroApp
      name="services/EditCourse"
      settings={settings}
      courseId={courseId}
    />
  );
}
